import React from 'react';
import { DayPickerProps, Day as BaseDay, useDayPicker } from 'react-day-picker-for-new-calendar';

import { Box } from '../../Box';
import styles from '../index.module.scss';


export const Day: DayPickerProps['components']['Day'] = props => {
    const { modifiers } = useDayPicker();
    return (
        <>
            <BaseDay {...props} />
            {modifiers.isRange && (
                <Box
                    className={styles.cellBg}
                    sx={{
                        position: 'absolute',
                        top: 1,
                        right: 0,
                        bottom: 1,
                        left: 0,
                        bgcolor: 'transparent',
                    }}
                />
            )}
        </>
    );
};
